<template>
    <!-- Frequência por período / notas por média do bimestre: liberação global por ano letivo -->
    <liberacao-periodos v-if="liberacaoPorPeriodo"></liberacao-periodos>
    <div class="main" v-else-if="!loading">

        <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="24">
                <label>Instituição</label>
                <el-select v-model="instituicao" filterable @change="selectIntituicao()">
                    <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                </el-select>
            </el-col>
        </el-row>

        <template v-if="instituicao">

            <el-tabs v-model="aba" class="u-mt-20">

                <el-tab-pane label="Notas" name="notas">
                    <el-form @submit.native.prevent="onSubmit" label-position="top">

                        <div class="u-mb-20" style="display: flex; align-items: center;">
                            <h3 class="u-mb-5">Lançamento de notas</h3>
                            <i style="margin-top: 10px; margin-left: 5px;">- Períodos disponíveis para lançamento de notas.</i>
                        </div>

                        <el-checkbox-group v-model="dados" class="checkbox-filtos">
                            <template v-for="(item, i) in periodos" >
                                <el-checkbox :label="i">{{ item }}</el-checkbox>
                            </template>
                        </el-checkbox-group>

                        <el-row :gutter="10">
                            <el-col :xs="24">
                                <el-form-item class="u-text-right">
                                    <el-button type="primary" native-type="submit">SALVAR</el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-tab-pane>

                <el-tab-pane label="Frequência" name="frequencia">
                    <el-form @submit.native.prevent="onSubmitFrequencia" label-position="top">

                        <div class="u-mb-20" style="display: flex; align-items: center;">
                            <h3 class="u-mb-5">Lançamento de frequência</h3>
                            <i style="margin-top: 10px; margin-left: 5px;">- Períodos disponíveis para lançamento de frequência. Período desmarcado fica só para consulta no diário.</i>
                        </div>

                        <el-alert v-if="frequenciaModo != 'periodo'" type="info" :closable="false" show-icon class="u-mb-20"
                            title="A frequência está configurada como chamada diária (Configurações do Sistema > Diário). Esta liberação só vale para o lançamento por período." />

                        <el-checkbox-group v-model="dadosFrequencia" class="checkbox-filtos">
                            <template v-for="(item, i) in periodosFrequencia" >
                                <el-checkbox :label="Number(i)">{{ item }}</el-checkbox>
                            </template>
                        </el-checkbox-group>

                        <el-row :gutter="10">
                            <el-col :xs="24">
                                <el-form-item class="u-text-right">
                                    <el-button type="primary" native-type="submit">SALVAR</el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-tab-pane>

            </el-tabs>

        </template>
        <template v-else>
            <div class="u-text-center u-mt-50">
                <i>Selecione uma instituição.</i>
            </div>
        </template>

    </div>
</template>
<script>

import LiberacaoPeriodos from './liberacao-periodos.vue'

export default {
    components: { LiberacaoPeriodos },
    computed: {
        liberacaoPorPeriodo () {
            const p = this.$store.state.config.parametros || {}
            return p.nota_modo === 'media_periodo' || p.frequencia_modo === 'periodo'
        }
    },
    data () {
        return {
            instituicao: '',
            loading: false,
            aba: 'notas',
            periodos:[],
            dados: [],
            periodosFrequencia: {},
            dadosFrequencia: [],
            frequenciaModo: 'diaria'
        }
    },
    methods:{
        selectIntituicao() {
            if(this.instituicao) {
                this.initFormParametros();
            }
        },
        async initFormParametros(){

            this.loading = true;

            let response = await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/diario/initFormParametros/${this.instituicao}`, this.$store.getters.getHeaderAuth);

            this.periodos = JSON.parse(JSON.stringify(response.data.options));

            this.dados = JSON.parse(JSON.stringify(response.data.dados));

            this.periodosFrequencia = JSON.parse(JSON.stringify(response.data.options_frequencia || {}));

            this.dadosFrequencia = (response.data.dados_frequencia || []).map(Number);

            this.frequenciaModo = response.data.frequencia_modo || 'diaria';

            this.loading = false;
        },
        async onSubmit (){

            window.eventBus.$emit('loading', true);

            let response = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/diario/storeParamAcoesNotas/${this.instituicao}`, this.dados, this.$store.getters.getHeaderAuth);

            if(typeof response.data.error !== 'undefined'){

                window.eventBus.$emit('loading', false);
                window.eventBus.$emit('alert', {msg: response.data.error, type: 'warning'});

            }else{

                window.eventBus.$emit('loading', false);
                window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                this.initFormParametros();
            }

        },
        async onSubmitFrequencia (){

            window.eventBus.$emit('loading', true);

            let response = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/diario/storeParamAcoesFrequencia/${this.instituicao}`, this.dadosFrequencia, this.$store.getters.getHeaderAuth);

            window.eventBus.$emit('loading', false);

            if(response.data && (response.data.erro || response.data.error)){

                window.eventBus.$emit('alert', {msg: response.data.erro || response.data.error, type: 'warning'});

            }else{

                window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                const aba = this.aba;
                await this.initFormParametros();
                this.aba = aba;
            }

        },
    }
}
</script>
